import { cn } from "@/shared/lib/utils"

import { TonRewardIcon } from "./../TonRewardIcon"
import { PRICE_BADGE_ICON_SIZE_PX } from "./PriceBadge.config"
import { priceBadgeStyles } from "./PriceBadge.styles"
import type { PriceBadgeProps } from "./PriceBadge.types"

export function PriceBadge({
  value,
  icon,
  iconSize = PRICE_BADGE_ICON_SIZE_PX,
  className,
  ...rest
}: PriceBadgeProps) {
  return (
    <div {...rest} className={cn(priceBadgeStyles.root, className)}>
      <span className={priceBadgeStyles.value}>{value}</span>
      {icon ?? (
        <TonRewardIcon size={iconSize} className={priceBadgeStyles.icon} />
      )}
    </div>
  )
}
